import React, { Component, Fragment } from "react";
import { setLoader, setDeeplink, setParams } from "../../../../redux/actions";
import { connect } from "react-redux";
import {
  Row,
  Card,
  CardBody,
  Alert,
  Badge
} from "reactstrap";
import { Colxx } from "../../../../components/common/CustomBootstrap";
import _axios from "../../../../libs/axios";
import { NotificationManager } from "../../../../components/common/react-notifications";
import ChartCard from "../../../../components/utils/ChartCard";
import AppLocale from "../../../../config/lang";
import CrudGrid from "../crudGrid";
import IconCard from '../../../../components/cards/IconCard';
import _moment from "../../../../libs/moment";
import CustomDropdown from "../../../../components/utils/CustomDropdown";
import PerfectScrollbar from 'react-perfect-scrollbar';
import FormCustom from "../../../../components/utils/FormCustom";
import { getNextDayOfWeek, objToQueryString } from "../../../../helpers/Utils";

class AdmCommunications extends Component {
  constructor(props) {
    super(props);
    this.M = "admCommunications."
    this.state = {
      data: [],
      form: null,
      formFields: [],
      formButtons: [],
      communicationTypes: [
        { id: "important", title: `${this.M}important`, icon: 'iconsminds-clock', value: '...'},
        { id: "act", title: `${this.M}eventsActivities`, icon: 'iconsminds-basket-coins', value: '...' },
        { id: "pub", title: `${this.M}newsPost`, icon: 'iconsminds-arrow-refresh', value: '...' },
        { id: "pho", title: `${this.M}photosMedia`, icon: 'iconsminds-mail-read', value: '...' }
      ],
      progressBar: false,
      chartNumberConvers: [],
      chartNumberMessages: [],
      notification: null,
      noCommunications: false,
      formSendSummary: null,
      formSendSummaryFields: [],
      successMsg: null
    }
  }

  UNSAFE_componentWillMount() {
    this.getData()
  }

  componentDidMount() {
    this.createForm()
  }

  componentDidUpdate(prevProps, prevState) {
  }

  componentWillUnmount() {
    this.props.setParams(null)
  }

  createForm () {
    const fields = [
      {
        col: 3,
        name: "label1",
        value: `${this.M}communicationType`,
        type: "label"
      },
      {
        col: 9,
        name: "commType",
        value: "pub",
        type: "radioGroup",
        rules: "required",
        opts: {
          style: 'float-label',
          inline: true,
          list: [
            {value: "pub", label: `${this.M}newsPost`},
            {value: "cal", label: `${this.M}eventsActivities`},
            {value: "pho", label: `${this.M}photosMedia`}
          ]
        }
      },
      {
        col: 3,
        name: "label2",
        value: "main.title",
        type: "label"
      },
      {
        col: 9,
        name: "topic",
        value: "",
        type: "text",
        rules: "required",
        opts: {
          style: 'float-label'
        }
      },
      {
        col: 3,
        name: "label3",
        value: `${this.M}briefSeed`,
        type: "label"
      },
      {
        col: 9,
        name: "seed",
        value: "",
        type: "textarea",
        rules: "required",
        opts: {
          style: 'float-label'
        }
      },
      {
        col: 3,
        name: "label4",
        value: `${this.M}communicationTone`,
        type: "label"
      },
      {
        col: 9,
        name: "tone",
        value: "",
        type: "radioGroup",
        rules: "required",
        opts: {
          style: 'float-label',
          inline: true,
          list: [
            {value: "Joyful", label: "admCommunications.joyful"},
            {value: "Inspiring", label: "admCommunications.inspiring"},
            {value: "Neutral", label: "admCommunications.neutral"},
            {value: "Serious", label: "admCommunications.serious"},
            {value: "Critical", label: "admCommunications.critical"}
          ]
        }
      },
      {
        col: 3,
        name: "label5",
        value: `${this.M}numberOfParagraphs`,
        type: "label"
      },
      {
        col: 9,
        name: "paragraphs",
        value: 1,
        type: "slider",
        rules: "required|numeric|min:1,num",
        opts: {
          slider: {
            min: 0,
            max: 20,
            step: 1
          }
        }
      }
    ]

    const buttons = [
      {
        col: 4,
        colxs: 6,
        name: "btnProceedManually",
        value: "",
        type: "button",
        label: "admCommunications.proceedManually",
        opts: {
          outline: true
        },
        onClick: () => this.createManually()
      },
      {
        col: 4,
        colxs: 6,
        name: "btnProceedWithAI",
        value: "",
        type: "button",
        label: "admCommunications.proceedWithAI",
        onClick: () => this.createWithAi()
      }
    ]
    this.setState({formFields: fields, formButtons: buttons})
  }

  createFormSendSummary (readMode = false) {
    const { notification } = this.state
    const fields = [
      {
        col: 6,
        name: "day",
        value: "",
        type: "select",
        label: "main.day",
        rules: "required",
        opts: {
          style: 'float-label',
          items: [
            {value: 1, label: "main.monday"},
            {value: 2, label: "main.tuesday"},
            {value: 3, label: "main.wednesday"},
            {value: 4, label: "main.thursday"},
            {value: 5, label: "main.friday"},
            {value: 6, label: "main.saturday"},
            {value: 0, label: "main.sunday"}
          ]
        }
      },
      {
        col: 3,
        name: "hour",
        value: "",
        type: "time",
        label: "main.hour",
        rules: "required",
        opts: {
          style: "float-label"
        }
      },
      {
        col: 3,
        name: "btnSendSummary",
        value: "",
        type: "button",
        label: "main.activate",
        onClick: () => { this.sendSummary() }
      }
    ]

    const fieldsReadMode = [
      {
        col: 3,
        name: "notificationActive",
        value: !!notification?.lastComm,
        type: "switch",
        label: "main.active"
      },
      {
        col: 3,
        name: "lastComm",
        value: (L) => `<b>${L[`${this.M}lastSend`]}</b><br>${notification?.lastComm ? _moment(notification.lastComm).format("MMM DD hhA") : ""}`,
        type: "label",
      },
      {
        col: 3,
        name: "nextComm",
        value: (L) => `<b>${L[`${this.M}nextSend`]}</b><br>${notification?.nextComm ? _moment(notification.nextComm).format("MMM DD hhA") : ""}`,
        type: "label",
      },
      {
        col: 3,
        name: "btnEdit",
        value: "",
        type: "button",
        label: "main.edit",
        onClick: () => {
          this.ctxAdmNotification.getDataById(notification?.notificationId)
        }
      },
      {
        col: 12,
        name: "alert2",
        value: () => this.state.successMsg,
        type: "alert",
        opts: {
          color: "info"
        },
        renderIf: () => this.state.successMsg
      },
    ]
    this.setState({formSendSummaryFields: notification?.notificationId > 0 || readMode ? fieldsReadMode : fields})
  }

  getData(loader = true, superSectionId) {
    if (loader) this.setState({ progressBar: true, data: []})
    const params = {
      toDate: `${_moment().format("YYYY-MM-DD")}`,
      superSectionId: superSectionId
    }
    const query = objToQueryString(params)
    _axios
      .get(`admCommunications/get?${query}`)
      .then(r => {
        if (r.status >= 0) {
          const setCardValue = (id, val) => this.state.communicationTypes.map(e => { if(e.id === id) e.value = val; return e } )
          setCardValue("act", r.data.totalEvents)
          setCardValue("important", r.data.totalImportant)
          setCardValue("pho", r.data.totalMedia)
          setCardValue("pub", r.data.totalNews)

          this.setState({
            data: r.data.grid.Results,
            noCommunications: r.data.grid.Results.length === 0,
            chartNumberConvers: r.data.chartNumberConvers,
            chartNumberMessages: r.data.chartNumberMessages,
            notification: {
              lastComm: r.data.lastComm,
              nextComm: r.data.nextComm,
              notificationActive: r.data.notificationActive,
              notificationId: r.data.notificationId,
            }
          }, () => { this.createFormSendSummary() /* console.log(this.state.data) */ })
        } else NotificationManager.error(r.msg, 'Opps', 4000, null, null, 'outline')
        this.setState({ progressBar: false })
      })
  }

  getCategory(item) {
    let cat = {}
    if (["pho"].indexOf(item.categName) > -1) cat = {id: 1, color: "success", name: this.state.communicationTypes.find(t => t.id === "pho")?.title}
    else if (["pub"].indexOf(item.categName) > -1) cat = {id: 2, color: "success", name: this.state.communicationTypes.find(t => t.id === "pub")?.title}
    else if (["act", "cal"].indexOf(item.categName) > -1) cat = {id: 3, color: "info", name: this.state.communicationTypes.find(t => t.id === "act")?.title}
    if (item.pinned) cat = {id: 4, color: "warning", name: `${this.M}important`}
    else if (item.published === false) cat = {id: 5, color: "danger", name: `${this.M}draft`}
    return cat
  }

  createManually () {
    this.validateFor(null, ['commType']).then((v) => {
      ["pub", "pho"].indexOf(this.state.form.commType) > -1 ? this.ctxAdmPublication.toggle() : this.ctxAdmCalendar.toggle()
    })
  }

  createWithAi () {
    this.validateForm().then(() => {
      this.props.setLoader(true)
      let body = this.state.form
      body = {...body, ...{AI: true}}
      _axios
        .post("admCommunications/create", body)
        .then(r => {
          this.props.setLoader(false)
          if (r.status >= 0) {
            const commType = this.state.form.commType
            const id = r.data;
            ["pub", "pho"].indexOf(commType) > -1 ? this.ctxAdmPublication.getDataById(id) : this.ctxAdmCalendar.getDataById(id)
            this.resetForm()
          }
          NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
        })
        .catch((e) => { this.props.setLoader(false) })
    })
    .catch(e => { /* console.log(e) */ })
  }

  sendSummary () {
    this.validateFormSendSummary().then(() => {
      this.props.setLoader(true)
      const { day, hour } = this.state.formSendSummary
      const date = getNextDayOfWeek(day)
      const time = _moment(hour).format("HH:mm")
      const dateTime = _moment(`${date} ${time}`)
      const  body = {
        name: "Weekly Comms",
        doWA: true,
        doWATemplate: "comms-en",
        placeholders: [],
        doMail: false,
        doPush: false,
        sendTo: 0,
        filterBy: "sections",
        page: "comms",
        objectId: null,
        sendOn: dateTime.format("YYYY-MM-DD HH:mm:ss"),
        hasRecurrence: true,
        recurrence: `0 ${dateTime.format("H")} * * ${day}`,
        confirm: false,
        selectedField: null
      }
      _axios
        .post("admNotification/create", body)
        .then(r => {
          this.props.setLoader(false)
          if (r.status >= 0) {
            this.createFormSendSummary(true)
            this.setState({ successMsg: r.msg })
          }
          NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
        })
        .catch((e) => { this.props.setLoader(false) })
    })
    .catch(e => { /* console.log(e) */ })
  }

  listenStatesForm = (s) => {
    this.setState({ form: s })
  }

  listenCreateSuccess = (success) => {
    if (success) this.getData()
  }

  listenEditSuccess = (success) => {
    if (success) this.getData(false)
  }

  listenDeleteSuccess = (success) => {
    if (success) this.getData(false)
  }

  listenStatesFormSendSummary = (s) => {
    this.setState({ formSendSummary: s })
  }

  render() {
    const { locale, params } = this.props
    const L = AppLocale[locale].messages
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Row>
              <Colxx xxs="12" xxl="6">
                <h1>{L[`${this.M}communications`]}</h1>
              </Colxx>
            </Row>
          </Colxx>
        </Row>

        {params?.setupMsg && <Alert className="rounded" color="warning">{params.setupMsg}</Alert>}

        <Row>
          <Colxx lg="12" xl="6">
            <Row className="icon-cards-row mt-0">
              {this.state.communicationTypes.map((item, index) => {
                  return (
                    <Colxx md="3" xxs="6" key={`icon_card_${index}`}>
                      <IconCard {...{...item, ...{L: L}}}/>
                    </Colxx>
                  )
                })
              }
            </Row>
            <Row>
              <Colxx md="12" className="mb-4">
                <Card >
                  <CardBody>
                    <div className="d-flex align-items-center">
                      <h5 className="mb-4">{L[`${this.M}composeCommunication`]}</h5>
                      {this.state.noCommunications && <div className="h5 error-color mb-4 ml-2"><i className="simple-icon-exclamation"></i></div>}
                    </div>
                    <FormCustom
                      id={"form-ai-communications"}
                      fields={this.state.formFields}
                      buttons={this.state.formButtons}
                      wrapButtonsWithDiv={true}
                      listenStates={this.listenStatesForm}
                      validate={fn => this.validateForm = fn}
                      validateFor={fn => this.validateFor = fn}
                      resetForm={fn => this.resetForm = fn}
                      didUpdateStates={true}
                    />
                  </CardBody>
                </Card>
              </Colxx>
            </Row>
          </Colxx>
          <Colxx lg="12" xl="6" className="mb-4">
            <Row>
              <Colxx md="12" className="mb-4">
                <Card>
                  <CardBody>
                    <div className="d-flex align-items-center">
                      <h5 className="mb-4">{L[`${this.M}sendSummaryToAllParents`]}</h5>
                    </div>
                    <FormCustom
                      id={"form-send-summary"}
                      fields={this.state.formSendSummaryFields}
                      listenStates={this.listenStatesFormSendSummary}
                      validate={fn => this.validateFormSendSummary = fn}
                      didUpdateStates={true}
                    />
                  </CardBody>
                </Card>
              </Colxx>
            </Row>
            <Row>
              <Colxx md="12">
                <Card>
                  <CardBody>
                    <div className="d-flex align-items-center mb-4 justify-content-between">
                      <h5 className="mb-0">{L[`${this.M}activeCommunicationsForTheWeek`]}</h5>
                      <CustomDropdown
                        label={"main.filter"}
                        direction="left"
                        resourceUrl={"/admSuperSection/get?pick=true"}
                        showItemSelected={true}
                        onChange= {(item) => {
                          this.getData(true, item.id)
                        }}
                      />
                    </div>
                    <div style={{height: '4px'}}>{this.state.progressBar && <div className="progress"><div className="indeterminate"></div></div>}</div>
                    {this.state.noCommunications && <Alert color="danger">{L["main.noRecords"]}</Alert>}
                    <div className="scroll dashboard-list-with-thumbs">
                      <PerfectScrollbar options={{ suppressScrollX: true, wheelPropagation: false }}>
                        {this.state.data.map((item, index) => {
                          const category = this.getCategory(item)
                          return (
                            <div key={index} className="d-flex flex-row mb-3">
                              <div className="d-block position-relative">
                                <img src={item.img?? require("../../../../assets/img/camera.png")} alt={""} className="list-thumbnail border-0" onError={(e)=>{e.target.onerror = null; e.target.src=require("../../../../assets/img/camera.png")}}/>
                                <Badge
                                  key={index}
                                  className="position-absolute badge-top-right truncate pl-2 pr-2"
                                  style={{width: "76px"}}
                                  color={category.color}
                                  pill
                                >
                                  {L[category.name]?? category.name}
                                </Badge>
                              </div>
                              <div className={`pl-3 pt-2 pr-2 pb-2 w-100 ${category.id === 5 ? "opacity-50" : ""}`}>
                                <p className="list-item-heading mb-1">{item.name}</p>
                                <div className="pr-4">
                                  <p className="text-muted mb-1 text-small">
                                    {item.desc}
                                  </p>
                                </div>
                                <div className="text-primary text-small font-weight-medium d-none d-sm-block">
                                  {_moment(item.publishFrom).format(window.tenant.defaultDateFormat)}
                                </div>
                              </div>
                              <div>
                                <CustomDropdown
                                  icon="simple-icon-options-vertical"
                                  direction="left"
                                  showMenuOnHover={true}
                                  style={{position: 'relative'}}
                                  items={[
                                    {icon: 'simple-icon-pencil', name: 'main.edit', onClick: () => {
                                      if (["pho", "pub"].indexOf(item.categName) > -1) this.ctxAdmPublication.getDataById(item.id)
                                      else this.ctxAdmCalendar.getDataById(item.id)
                                    }},
                                    {icon: 'simple-icon-trash', name: 'main.delete', onClick: () => {
                                      if (["pho", "pub"].indexOf(item.categName) > -1) this.ctxAdmPublication.toggleDelete(item.id)
                                      else this.ctxAdmCalendar.toggleDelete(item.id)
                                    }}
                                  ]}
                                />
                              </div>
                            </div>
                          )
                        })}
                      </PerfectScrollbar>
                    </div>
                  </CardBody>
                </Card>
              </Colxx>
            </Row>
          </Colxx>
        </Row>

        <Row>
          <Colxx lg="12" xl="6" className="mb-4">
            <ChartCard data={this.state.chartNumberMessages} L= {L} title={`${this.M}numberOfMessages`} caption={`${this.M}fromParents`}/>
          </Colxx>
          <Colxx lg="12" xl="6" className="mb-4">
            <ChartCard data={this.state.chartNumberConvers}  L= {L} title={`${this.M}numberOfConversations`} caption={`${this.M}uniquePerParent`}  />
          </Colxx>
        </Row>

        <CrudGrid
          ctx={ctx => this.ctxAdmPublication = ctx}
          match={{ path: '/app/admPublication' }}
          onlyCrud={true}
          listenCreateSuccess={this.listenCreateSuccess}
          listenEditSuccess={this.listenEditSuccess}
          listenDeleteSuccess={this.listenDeleteSuccess}
        />

        <CrudGrid
          ctx={ctx => this.ctxAdmCalendar = ctx}
          match={{ path: '/app/admCalendar' }}
          onlyCrud={true}
          listenCreateSuccess={this.listenCreateSuccess}
          listenEditSuccess={this.listenEditSuccess}
          listenDeleteSuccess={this.listenDeleteSuccess}
        />

        <CrudGrid
          ctx={ctx => this.ctxAdmNotification = ctx}
          match={{ path: '/app/admNotification' }}
          onlyCrud={true}
          listenCreateSuccess={this.listenCreateSuccess}
          listenEditSuccess={this.listenEditSuccess}
          listenDeleteSuccess={this.listenDeleteSuccess}
        />
      </Fragment>
    )
  }
}

const mapStateToProps = ({ settings, menu, utils, authUser }) => {
  const { menuItems } = menu
  const { locale } = settings
  const { deepLink, params } = utils
  const { userAdmin } = authUser
  return { locale, menuItems, deepLink, params, userAdmin }
}

export default connect(mapStateToProps, { setLoader, setDeeplink, setParams })(AdmCommunications);